import React from "react";
import PropTypes from "prop-types";
import Modal from "../../shared/modal";
import styles from "./styles.css";
import ThankyouImage from "./images/thank-you.svg";
import CallIcon from "./images/call.svg";
import EmailIcon from "./images/email.svg";
import TextIcon from "./images/text.svg";
import { HELPLINE_NUMBER_AU, SMS_NUMBER_AU, SUPPORT_EMAIL } from "../../../constants/app-constants";
import CloseButton from "../../shared/icon-cross";
import Button from "../../shared/button";
import getResumeFilterListingUrl from "../../../utils/helpers/get-resume-filter-listing-url";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";

const CommingSoonThankModal = ({
    title,
    onClose,
    resetCarListConnect,
    reloadCarListConnect
}) => {

    const trackEvent = (e, label) => {
        const eventLabel = label || (e && e.target.getAttribute("data-attribute"));
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.COMING_SOON_THANK_YOU, {eventLabel});
    };

    const onClickListingPage = () => {
        const absoluteURL = getResumeFilterListingUrl();
        resetCarListConnect();
        reloadCarListConnect(true);
        onClose();
        trackEvent(null, "see_similar_cars");
        window.location.href = absoluteURL;
        window.setTimeout(() => window.scrollTo(0, 0));
    };

    return (
        <React.Fragment>
            <Modal isOpen={true}>
                <div styleName={"styles.wrapper"}>
                    <span styleName={"styles.close"}><CloseButton type={"grey"} onClickHandler={onClose}/></span>
                    <h3 styleName={"styles.modalTitle"}>Thank You!</h3>
                    <p styleName={"styles.modalContentText"}>We’ve added this <strong>{title}</strong> to your wishlist!</p>
                    <img src={ThankyouImage} styleName={"styles.modalImage"} alt="Thank You" />
                    <p styleName={"styles.modalContentText"}>We’ll notify you once this car is available for purchase!</p>
                    <div styleName={"styles.touchWrapper"}>
                        <h4>Get in touch with us today!</h4>
                        <p styleName="styles.queryText">For any queries our team is available to help </p>
                        <ul styleName={"styles.touchList"} onClick={trackEvent}>
                            <li>
                                <a href={`tel:${HELPLINE_NUMBER_AU.value}`} >
                                    <img src={CallIcon} alt="Call Us" data-attribute="call"/> Call Us
                                </a>
                            </li>
                            <li>
                                <a href={`mailto:${SUPPORT_EMAIL}`} >
                                    <img src={EmailIcon} alt="Email Us" data-attribute="email"/> Email Us
                                </a>
                            </li>
                            <li>
                                <a href={`sms:${SMS_NUMBER_AU.value}`} >
                                    <img src={TextIcon} alt="Text Us" data-attribute="text"/> Text Us
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div styleName={"styles.buttonWrap"}>
                        <Button text={"SEE SIMILAR CARS"} onClick={onClickListingPage}/>
                    </div>
                </div>
            </Modal>
        </React.Fragment>
    );
};

CommingSoonThankModal.propTypes = {
    onClose: PropTypes.func,
    title: PropTypes.string,
    history: PropTypes.object,
    reloadCarListConnect: PropTypes.func,
    resetCarListConnect: PropTypes.func
};

export default CommingSoonThankModal;
